

<template>
  <v-container>
    <v-row align="center" justify="center" class="my-4">
      <v-col cols="12" md="8" class="text-center">
        <div class="d-flex flex-wrap justify-center align-center">

          <v-chip color="primary" class="ma-1" outlined>
            Zona: {{ zonaNombre }}
          </v-chip>

          <v-chip
            :color="isTpv ? 'green darken-2' : 'blue darken-2'"
            dark
            class="ma-1"
          >
            Modo: {{ isTpv ? 'TPV' : 'Tablet' }}
          </v-chip>

          <h2 class="text-h5 font-weight-bold mr-4 mb-0"> Inventario </h2>

          <v-btn color="primary" @click="refrescarDatos" small>
            <v-icon left>mdi-refresh</v-icon>
            Actualizar datos
          </v-btn>

          <v-btn
              color="warning"
              class="ma-4"
              small
              @click="abrirPopupArticulosIntroducidos"
            >
              Exist/Modif
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <!-- Panel de filtros -->
    <v-expansion-panels v-model="activePanels">
      <v-expansion-panel>
        <v-expansion-panel-header>Filtros
          <v-col cols="2" sm="3" md="2">
            <v-btn
              color="primary"
              class="mt-2"
              small
              @click="resetFiltros"
            >
              Borrar filtros
            </v-btn>
            </v-col>

        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="2" sm="3" md="2">
            <v-select
              v-model="filtros.familia"
              :items="familiasDisponibles"
              label="Familia"
              clearable
              @change="() => { filtros.subfamilia = null; triggerSearch(); }"
            />
            </v-col>
            <v-col cols="2" sm="3" md="2" v-if="$store.state.empId==1 || $store.state.empId==2 || $store.state.empId==3 || $store.state.empId==11 || $store.state.empId==14">
              <v-select
                v-model="filtros.subfamilia"
                :items="subfamiliasDisponibles"
                label="Subfamilia"
                clearable
                @change="triggerSearch"
              />
            </v-col>
            <v-col cols="2" sm="3" md="2">
              <v-autocomplete
                v-model="filtros.Art"
                :items="artList"
                item-value="xarticulo_id"
                item-text="xdescripcion"
                label="Artículo"
                return-object
                clearable
                @change="triggerSearch"
              />
            </v-col>

            <v-col cols="2" sm="3" md="2">
              <v-text-field
                v-model="filtros.xarticulo_id"
                label="Código"
                clearable
                @change="triggerSearch"
                @keyup.enter="triggerSearch"

              />
            </v-col>
            <v-col cols="2" sm="3" md="2">
              <v-text-field
                v-model="eanDelay"
                append-outer-icon="mdi-magnify"
                label="Código de barras (EAN)"
                @click:append-outer="buscarPorEAN"
                @keyup.enter="buscarPorEAN"
                @click:clear="limpiarFiltroEAN"
                clearable
              />
            </v-col>

            <v-col cols="2" sm="3" md="2" v-if="$store.state.empId==8 || $store.state.empId==12 || $store.state.empId==15">
              <v-text-field
                v-model="filtros.plu"
                label="Buscar por PLU"
                clearable
              />
            </v-col>

            <!-- <v-col cols="2" sm="3" md="2">
            <v-btn
              color="warning"
              class="ma-4"
              small
              @click="abrirPopupArticulosIntroducidos"
            >
              Existencias
            </v-btn>
            </v-col> -->
<!-- 
            <v-col cols="3" sm="6" md="3">
              <v-checkbox
                v-model="filtros.Pendiente"
                label="Mostrar solo pendientes"
                @change="triggerSearch"
              />
            </v-col> 
            -->

            
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    

    <!-- Tabla -->
    <v-data-table
      :headers="headers"
      :items="dataRows"
      :custom-filter="tableCustomFilter"
      :search="searchTrigger"
      :loading="loading"
      :options.sync="options"
      dense
      class="elevation-1 mt-4"
    >

    <template v-slot:item.factorCompra="{ item }">
      {{ Number(item.Art.FactorCompra || 0).toFixed(2) }}
    </template>

    <template v-slot:item.Art.existenciaTotal="{ item }">
      {{ item.Art.existenciaTotal !== null ? item.Art.existenciaTotal : '-' }}
    </template>

      <!-- Existencia editable -->
      <template v-slot:item.Existencia="{ item }">
  <div v-if="!item.new">{{ item.Existencia }}</div>
  <div
    v-else
    class="d-flex align-center"
    :style="{ backgroundColor: item.guardadoCorrectamente ? '#e6f4ea' : '' }"
  >
    <!-- Campo con validación y tooltip -->
    <v-tooltip bottom v-if="item.errorValidacion">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="item.Existencia"
          type="number"
          outlined
          dense
          hide-details
          class="my-1"
          style="max-width: 100px"
          :error="item.errorValidacion"
          v-bind="attrs"
          v-on="on"
          :id="`existencia-${item.Art.xarticulo_id}`"
          @input="validarExistenciaCampo(item)"
          @change="guardarExistenciaLinea(item)"
        />
      </template>
      <span>{{ obtenerMensajeError(item) }}</span>
    </v-tooltip>

    <!-- Campo normal si no hay error -->
    <v-text-field
      v-else
      v-model="item.Existencia"
      :ref="'existencia-' + item.Art.xarticulo_id"
      type="number"
      outlined
      dense
      hide-details
      class="my-1"
      style="max-width: 100px"
      :id="`existencia-${item.Art.xarticulo_id}`"
      @blur="guardarExistenciaLinea(item)"
      :error="item.errorValidacion"

    />

    <!-- Icono de check a la derecha si guardadoCorrectamente -->
    <v-icon
      v-if="item.guardadoCorrectamente"
      color="green"
      class="ml-2"
    >
      mdi-check-circle
    </v-icon>

    <!-- Botón PESO si unidad no es UN -->
    <v-btn
      v-if="item.Art.unidadPrincipal !== 'UN'"
      small
      color="primary"
      class="ml-2"
      @click="onBtnCapturarPeso(item)"
    >
      PESO
    </v-btn>
  </div>
</template>
    </v-data-table>
    <!-- Diálogo de confirmación para cantidades atípicas -->
    <v-dialog v-model="dialogoConfirmacion.visible" max-width="400">
      <v-card>
        <v-card-title class="headline">
          Confirmar cantidad atípica
        </v-card-title>

        <v-card-text>
          ¿Estás seguro de que quieres guardar la línea con una cantidad de
          <strong>{{ dialogoConfirmacion.item ? dialogoConfirmacion.item.Existencia : '' }}</strong>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn text color="red" @click="dialogoConfirmacion.visible = false">
            Cancelar
          </v-btn>
          <v-btn text color="green" @click="confirmarGuardarLinea">
            Sí, guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogoArticulosIntroducidos" max-width="900">
      <v-card>
        <v-card-title class="headline">
          Artículos introducidos
          <v-spacer />
          <v-btn icon @click="dialogoArticulosIntroducidos = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12" sm="3">
              <v-select
                v-model="filtrosIntroducidos.familia"
                :items="familiasDisponibles"
                label="Familia"
                clearable
              />
            </v-col>
            <v-col cols="12" sm="3">
              <v-select
                v-model="filtrosIntroducidos.subfamilia"
                :items="subfamiliasPopup"
                label="Subfamilia"
                clearable
              />
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="filtrosIntroducidos.xarticulo_id"
                label="Código artículo"
                clearable
              />
            </v-col>
            <v-col cols="12" sm="3">
              <v-select
                v-model="filtrosIntroducidos.zona"
                :items="zonasDisponibles"
                label="Zona"
                item-text="text"
                item-value="value"
                clearable
              />
            </v-col>
          </v-row>

          <v-data-table
            v-if="!loadingLineasIntroducidas"
            :headers="headersIntroducidos"
            :items="articulosIntroducidosFiltrados"
            dense
            class="elevation-1"
          >

          <template v-slot:item.zona="{ item }">
              {{ item.ZonaId === 1 ? 'A' : item.ZonaId === 2 ? 'T' : '' }}
          </template>
            <!-- Descripción del artículo -->
            <template v-slot:item.Art.xdescripcion="{ item }">
              {{ item.Art.xdescripcion }}
            </template>

            <!-- Código del artículo -->
            <template v-slot:item.Art.xarticulo_id="{ item }">
              {{ item.Art.xarticulo_id }}
            </template>

            <!-- Existencia actual -->
            <template v-slot:item.Existencia="{ item }">
              {{ item.Existencia }}
            </template>

            <!-- Campo para introducir ajuste -->
            <template v-slot:item.ajuste="{ item }">
              <v-text-field
                v-model.number="item.ajuste"
                type="number"
                step="0.01"
                dense
                hide-details
                style="max-width: 80px"
                class="mt-2"
              />
            </template>

            <!-- Botón para aplicar el ajuste -->
            <template v-slot:item.actions="{ item }">
              <v-btn
                small
                color="primary"
                @click="aplicarAjuste(item)"
                :disabled="!esAjusteValido(item.ajuste, item)"
                class="mt-2"
              >
                Aplicar
              </v-btn>
              <v-icon
                v-if="item.guardadoOk"
                color="green"
                class="ml-2 mt-2"
              >
                mdi-check-circle
              </v-icon>
            </template>
          </v-data-table>

          <!-- Loader mientras se cargan las líneas -->
          <v-skeleton-loader v-else type="table" class="my-4"></v-skeleton-loader>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn text color="primary" @click="dialogoArticulosIntroducidos = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Botones de acción -->
    <v-footer app padless>
      <v-row class="mt-4 mb-2" justify="center">
        <!-- <v-btn color="success" class="mx-2" @click="onBtnSave"   :disabled="existeAlgunaLineaInvalida()"        >Guardar</v-btn> -->
        <v-btn class="mx-2" @click="goToList">Salir</v-btn>
        <!-- <v-btn @click="dialogoConfirmacion.visible = true">Forzar Diálogo</v-btn> -->

      </v-row>
    </v-footer>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  data() {
    return {
      activePanels: 0,
      loading: false,
      inventario: { InventarioId: null },
      isTpv: false,
      zonaId: null,
      artList: [],
      dataRows: [],
      searchTrigger: "0",
      familiasDisponibles: [],
      subFamiliasDisponibles: [],
      filtros: {
        Art: null,
        xarticulo_id: "",
        Pendiente: false,
        familia: null,
        subFamilia: null,
        ean: '', 
        plu: '', 
      },
      headers: [
        { text: "Artículo", value: "Art.xdescripcion" },
        { text: "Formato", value: "factorCompra" },
        { text: "Código", value: "Art.xarticulo_id" },
        { text: "Existencia", value: "Existencia" },
        { text: "Total Inventario", value: "Art.existenciaTotal" }
      ],
      options: {
      page: 1,
      itemsPerPage: 15
      },
      dialogoConfirmacion: {
        visible: false,
        item: null
      },
      snackbarVisible: false,
      snackbarMensaje: '',
      filtrosGeneral: {
                Dir: null,
                PerId: null,
                Zona: null
            },
            dialogoArticulosIntroducidos: false,
      lineasIntroducidas: [],
      filtrosIntroducidos: {
        familia: null,
        subfamilia: null,
        xarticulo_id: ""
      },
      loadingLineasIntroducidas: false, // Opcional: para mostrar spinner de carga
      headersIntroducidos: [
        { text: "Zona", value: "zona", sortable: false },
        { text: "Código", value: "Art.xarticulo_id" },
        { text: "Descripción", value: "Art.xdescripcion" },
        { text: "Existencia", value: "Existencia" },
        { text: "Ajuste (+ / -)", value: "ajuste", sortable: false },
        { text: "Acciones", value: "actions", sortable: false }
      ],
      zonasDisponibles: [
        { text: 'Almacén', value: 1 },
        { text: 'Tienda', value: 2 }
      ],
      eanDelay: '',       // ← este se enlaza al input
      eanTimeout: null    // ← para el debounc
    };
  },
  computed: {
    ...mapState(['empId', 'perId', 'perIdAux', 'urlRaiz', 'esTienda', 'esEmpleado', 'dirId']),
    // filteredRows() {
    //   if (!this.filtros.familia) {
    //     return this.dataRows;
    //   }

    //   const filtroFam = this.filtros.familia.toLowerCase();

    //   return this.dataRows.filter(
    //     (item) =>
    //       item.Art.familia &&
    //       item.Art.familia.toLowerCase().includes(filtroFam)
    //   );
    // },
    // filteredRows() {
    //   let rows = this.dataRows;

    //   if (this.filtros.familia) {
    //     const fam = this.filtros.familia.toLowerCase();
    //     rows = rows.filter(item =>
    //       item.Art.familia && item.Art.familia.toLowerCase() === fam
    //     );
    //   }

    //   if (this.filtros.subfamilia) {
    //     const sub = this.filtros.subfamilia.toLowerCase();
    //     rows = rows.filter(item =>
    //       item.Art.subfamilia && item.Art.subfamilia.toLowerCase() === sub
    //     );
    //   }

    //   return rows;
    // },
    subfamiliasDisponibles() {
      if (!this.filtros.familia) return [];

      return [...new Set(
        this.artList
          .filter(a =>
            a.familia &&
            a.subfamilia &&
            a.familia.toLowerCase() === this.filtros.familia.toLowerCase()
          )
          .map(a => a.subfamilia)
      )].sort();
    },
    zonaNombre() {
      switch (this.zonaId) {
        case '1':
        case 1:
          return 'Almacén';
        case '2':
        case 2:
          return 'Tienda';
        default:
          return `Zona ${this.zonaId}`;
      }
    },
    subfamiliasPopup() {
      const fam = this.filtrosIntroducidos.familia;
      if (!fam) return [];

      return [...new Set(
        this.lineasIntroducidas
          .filter(r => r.Art.familia === fam && r.Art.subfamilia)
          .map(r => r.Art.subfamilia)
      )].sort();
    },

    articulosIntroducidosFiltrados() {
      return this.lineasIntroducidas.filter(item => {
        const famOk = !this.filtrosIntroducidos.familia || item.Art.familia === this.filtrosIntroducidos.familia;
        const subfamOk = !this.filtrosIntroducidos.subfamilia || item.Art.subfamilia === this.filtrosIntroducidos.subfamilia;
        // const codOk = !this.filtrosIntroducidos.xarticulo_id ||
        //   item.Art.xarticulo_id.toLowerCase().includes(this.filtrosIntroducidos.xarticulo_id.toLowerCase());

          const filtroTexto = this.filtrosIntroducidos.xarticulo_id?.toLowerCase() || '';
        const codOk =
          !filtroTexto ||
          item.Art.xarticulo_id?.toLowerCase().includes(filtroTexto) ||
          item.Art.xdescripcion?.toLowerCase().includes(filtroTexto);

        const zonaOk = !this.filtrosIntroducidos.zona || item.ZonaId === this.filtrosIntroducidos.zona;

        return famOk && subfamOk && codOk && zonaOk;
      });
    }
  },
  watch: {
    'filtros.familia'(val) {
      if (!val) {
        this.options.page = 1;
        this.$nextTick(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
    }
  },
  mounted() {

    this.inventario.InventarioId = this.$route.params.id;
    this.zonaId = this.$route.params.zona;

    // Esto es lo importante:
    this.isTpv = this.$route.params.tpv === '1';

    if (this.esTienda) {
            this.filtrosGeneral.Dir = this.$store.state.dir;
    }

        // Per init.
        if (this.esEmpleado)
        {
            this.filtrosGeneral.PerId = this.perId;
        }
        else if(this.perIdAux != null && this.perIdAux != 0)
        {
            this.filtrosGeneral.PerId = this.perIdAux;
        }

    this.loadData();
  },
  methods: {
    async refrescarDatos() {
      this.loading = true;
      await this.loadData();
      this.loading = false;
    },
    abrirPopupArticulosIntroducidos() {
    this.dialogoArticulosIntroducidos = true;
    this.cargarLineasIntroducidas();
    },
    // onInputEAN() {
    //   clearTimeout(this.eanTimeout);
    //   this.eanTimeout = setTimeout(() => {
    //     this.filtros.ean = this.eanDelay; // ← se aplica el filtro real
    //   }, 1000); // 1 segundo
    // },
    limpiarFiltroEAN() {
      this.eanDelay = '';
      this.filtros.ean = '';
    },
    buscarPorEAN() {
        const texto = this.eanDelay.trim();
        this.filtros.ean = texto;
    },
    triggerSearch() {
      this.searchTrigger = this.searchTrigger === "0" ? "1" : "0";
      this.focusEnPrimeraCoincidencia();
    },
    //load data bueno antes del cambio
    // async loadData() {
    //   this.loading = true;
    //   try {
    //     const artResponse = await axios.post(
    //       `${this.urlRaiz}/api/artprov/arts/list/`,
    //       {
    //         EmpId: this.empId,
    //         DirId: this.$store.state.dirId,
    //         NumRegsPag: 6000,
    //         NumPag: 1,
    //         EsInventarios: 1,
    //         FamiliasExcluidas: [],
    //         ZonaId: this.zonaId,
    //         InventarioId: this.inventario.InventarioId
    //       },
    //       { headers: { Authorization: localStorage.getItem("token") } }
    //     );
    //     this.artList = artResponse.data.EntsList;
    //     this.dataRows = this.artList.map((m) => ({
    //       Art: m,
    //       Existencia: 0,
    //       new: true,
    //       pendiente: true,
    //       errorValidacion: false,
    //       ultimaExistenciaGuardada: 0 
    //     }));
    //     const familias = this.artList
    //     .map((a) => a.familia)
    //     .filter((f) => !!f) // Elimina nulos/vacíos
    //     .filter((value, index, self) => self.indexOf(value) === index) // Únicos

    //     this.familiasDisponibles = familias.sort();

    //   } catch {
    //     alert("Error cargando datos");
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    //fin loaddata bueno

    async loadData() {
      this.loading = true;
      try {
        const artResponse = await axios.post(
          `${this.urlRaiz}/api/artprov/arts/list-extendido`, // nuevo endpoint
          {
            EmpId: this.empId,
            DirId: this.$store.state.dirId,
            NumRegsPag: 6000,
            NumPag: 1,
            EsInventarios: 1,
            FamiliasExcluidas: [],
            ZonaId: this.zonaId,
            InventarioId: this.inventario.InventarioId
          },
          { headers: { Authorization: localStorage.getItem("token") } }
        );

        this.artList = artResponse.data.EntsList;

        // this.dataRows = this.artList.map((m) => ({
        //   Art: m,
        //   Existencia: 0,
        //   new: true,
        //   pendiente: true,
        //   errorValidacion: false,
        //   ultimaExistenciaGuardada: 0
        // }));

         this.dataRows = this.artList.map((m) => {
            const eanSearch = [m.EAN1, m.EAN2, m.EAN3, m.EAN4, m.EAN5]
              .filter(Boolean)
              .map(e => e.toLowerCase())
              .join(' ');

            return {
              Art: {
                ...m,
                eanSearch
              },
              Existencia: 0,
              new: true,
              pendiente: true,
              errorValidacion: false,
              ultimaExistenciaGuardada: 0
            };
          });

        const familias = this.artList
          .map((a) => a.familia)
          .filter((f) => !!f)
          .filter((value, index, self) => self.indexOf(value) === index);

        this.familiasDisponibles = familias.sort();

      } catch {
        alert("Error cargando datos");
      } finally {
        this.loading = false;
      }
    },

    // focusEnPrimeraCoincidencia() {
    //   const match = this.dataRows.find((item) => {
    //     if (
    //       this.filtros.Art &&
    //       item.Art.xarticulo_id === this.filtros.Art.xarticulo_id
    //     ) return true;

    //     if (
    //       this.filtros.xarticulo_id &&
    //       item.Art.xarticulo_id.toLowerCase().includes(this.filtros.xarticulo_id.toLowerCase())
    //     ) return true;

    //     return false;
    //   });

    //   if (match) {
    //     this.$nextTick(() => {
    //       const el = document.getElementById(`existencia-${match.Art.xarticulo_id}`);
    //       if (el) {
    //         el.scrollIntoView({ behavior: "smooth", block: "center" });
    //         el.focus();
    //       }
    //     });
    //   }
    // },
    focusEnPrimeraCoincidencia() {
    const index = this.dataRows.findIndex((item) => {
    const codigo = item.Art.xarticulo_id?.toLowerCase();
    const filtroCod = this.filtros.xarticulo_id?.toLowerCase();

    // Coincidencia exacta por objeto artículo seleccionado
    if (
      this.filtros.Art &&
      item.Art.xarticulo_id === this.filtros.Art.xarticulo_id
    ) return true;

    // Coincidencia parcial por texto del código
    if (
      filtroCod &&
      codigo.includes(filtroCod)
    ) return true;

    return false;
  });

  if (index >= 0) {
    const pageSize = this.options.itemsPerPage || 15;
    const pageToGo = Math.floor(index / pageSize) + 1;

    this.options.page = pageToGo;

    this.$nextTick(() => {
      const id = `existencia-${this.dataRows[index].Art.xarticulo_id}`;
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        el.focus();
      }
    });
  }
},

    // tableCustomFilter(value, search, item) {
    //   const artFilter =
    //     !this.filtros.Art || item.Art.xarticulo_id === this.filtros.Art.xarticulo_id;

    //   const artCodFilter =
    //     !this.filtros.xarticulo_id ||
    //     item.Art.xarticulo_id.toLowerCase().includes(this.filtros.xarticulo_id.toLowerCase());

    //   const familiaFilter =
    //     !this.filtros.familia || item.Art.familia === this.filtros.familia;

    //   const pendienteFilter = !this.filtros.Pendiente || item.pendiente;

    //   return artFilter && artCodFilter && familiaFilter && pendienteFilter;
    // },

    tableCustomFilter(value, search, item) {
      const artFilter =
        !this.filtros.Art || item.Art.xarticulo_id === this.filtros.Art.xarticulo_id;

      // const artCodFilter =
      //   !this.filtros.xarticulo_id ||
      //   item.Art.xarticulo_id.toLowerCase().includes(this.filtros.xarticulo_id.toLowerCase());

      const filtroTexto = this.filtros.xarticulo_id?.toLowerCase() || '';

      const textoEan = (this.filtros.ean || '').toLowerCase();
      //BUENO const eanFilter = !textoEan || (item.Art.eanSearch && item.Art.eanSearch.includes(textoEan));

      let eanFilter = true; // por defecto no filtra si no hay texto

      if (textoEan) {
        if (item.Art.EAN1 && item.Art.EAN1.toLowerCase().includes(textoEan)) {
          eanFilter = true;
        } else {
          // solo si no coincide en EAN1, buscar en los demás
          const otrosEans = [item.Art.EAN2, item.Art.EAN3, item.Art.EAN4, item.Art.EAN5];
          eanFilter = otrosEans
            .filter(Boolean)
            .some(e => e.toLowerCase().includes(textoEan));
        }
      }

      const textoPlu = (this.filtros.plu || '').toLowerCase();
      const pluFilter = !textoPlu || (item.Art.PLU1 && item.Art.PLU1.toLowerCase() === textoPlu);

      // const textoEan = (this.filtros.ean || '').toString().toLowerCase();
      // const eanMatches = [item.Art.EAN1, item.Art.EAN2, item.Art.EAN3, item.Art.EAN4, item.Art.EAN5]
      //   .filter(e => !!e)
      //   .some(e => e.toLowerCase().includes(textoEan));
      // const eanFilter = !textoEan || eanMatches;
      
    //   const eanMatches = [item.Art.EAN1, item.Art.EAN2, item.Art.EAN3, item.Art.EAN4, item.Art.EAN5]
    // .filter(e => !!e) 
    // .some(e => e.toLowerCase().includes(filtroTexto));

      // const artCodOrNombreFilter =
      //   !filtroTexto ||
      //   item.Art.xarticulo_id?.toLowerCase() === filtroTexto ||
      //   item.Art.xdescripcion?.toLowerCase().includes(filtroTexto);

      let artCodOrNombreFilter = true;

      if (filtroTexto) {
        const esNumero = /^\d+$/.test(filtroTexto); // Solo números

        if (esNumero) {
          artCodOrNombreFilter = item.Art.xarticulo_id?.toLowerCase() === filtroTexto;
        } else {
          artCodOrNombreFilter = item.Art.xdescripcion?.toLowerCase().includes(filtroTexto);
        }
      }
      // const artCodOrNombreFilter =
      //   !filtroTexto ||
      //   (item.Art.xarticulo_id && item.Art.xarticulo_id.toString().toLowerCase() === filtroTexto) || // match exacto
      //   (item.Art.xdescripcion && item.Art.xdescripcion.toLowerCase().includes(filtroTexto)); 

      const familiaFilter =
        !this.filtros.familia || item.Art.familia === this.filtros.familia;

      const subfamiliaFilter =
        !this.filtros.subfamilia || item.Art.subfamilia === this.filtros.subfamilia;

      const pendienteFilter = !this.filtros.Pendiente || item.pendiente;

      return artFilter && artCodOrNombreFilter && familiaFilter && subfamiliaFilter && pendienteFilter && eanFilter && pluFilter;
    },
    validarExistenciaCampo(item) {
      const unidad = item.Art.unidadPrincipal;
      const valor = String(item.Existencia).replace(",", ".");
      const numero = parseFloat(valor);

      if (unidad === 'UN') {
        const esEntero = parseInt(valor) === parseFloat(valor);
        const valido = esEntero && numero >= 0 && numero <= 1000;
        item.errorValidacion = !valido;
      } else {
        const valido = !isNaN(numero) && numero >= 0 && numero <= 10;
        item.errorValidacion = !valido;
      }
    },
    obtenerMensajeError(item) {
      const unidad = item.Art.unidadPrincipal;
      if (unidad === 'UN') {
        return 'Debe ser un número entero entre 0 y 1000';
      } else {
        return 'Debe ser un número decimal entre 0 y 10';
      }
    },
    existeAlgunaLineaInvalida() {
      return this.dataRows.some((r) => r.new && r.errorValidacion);
    },
    onBtnSave() {
      alert("Guardar inventario (simulado)");
    },
    goToList() {
      this.$router.push("/inventarios");
    },
    // resetFiltros() {
    //   this.filtros = {
    //     Art: null,
    //     xarticulo_id: '',
    //     Pendiente: false,
    //     familia: null,
    //     subfamilia: null
    //   };
    //   this.searchTrigger = this.searchTrigger === '0' ? '1' : '0';
    //   this.options.page = 1;

    //   this.$nextTick(() => {
    //     window.scrollTo({ top: 0, behavior: 'smooth' });
    //   });
    // },

    resetFiltros() {
      this.filtros = {
        Art: null,
        xarticulo_id: '',
        Pendiente: false,
        familia: null,
        subfamilia: null
      };
      this.options.page = 1;

      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    async onBtnCapturarPeso(item) {
      try {
        const res = await axios.get("http://localhost:5000/capturar_peso");
        console.log(res.data.peso);
        item.Existencia = res.data.peso;
        //item.Existencia = 1;

        this.$nextTick(() => {
          const refNombre = 'existencia-' + item.Art.xarticulo_id;
          const refCampo = this.$refs[refNombre];

          if (Array.isArray(refCampo)) {
            refCampo[0]?.focus();
          } else {
            refCampo?.focus();
          }
        });

      } catch {
        alert("Error al capturar peso");
      }
    },
    guardarExistenciaLinea(item) {
      // this.validarExistenciaCampo(item);
      // if (item.errorValidacion) return;

        this.$nextTick(() => {
        const unidad = item.Art.unidadPrincipal;
        
        const valor = parseFloat(String(item.Existencia).replace(',', '.'));
  
        const valorAnterior = parseFloat(String(item.ultimaExistenciaGuardada).replace(',', '.'));
        if (valor === valorAnterior) {
          console.log("No se guarda porque el valor no ha cambiado");
          return;
        }

        const cantidadEsCero = valor === 0;

        if (cantidadEsCero) {
          console.log("No se guarda porque la cantidad es 0");
          return;
        }

        const cantidadSospechosa =
          (unidad === 'UN' && (valor < 0 || valor > 1000 || !Number.isInteger(valor))) ||
          (unidad !== 'UN' && (valor < 0 || valor > 10));

        if (cantidadSospechosa) {
          this.dialogoConfirmacion.item = item;
          this.dialogoConfirmacion.visible = true;
          return;
        }

        //this.realizarGuardado(item);

            // Llamar a guardar y actualizar referencia
        const guardadoCorrecto = this.realizarGuardado(item);


        if (guardadoCorrecto) {

          if (item.Art.existenciaTotal != 0) {
            //const diferencia = valor + valorAnterior;
            item.Art.existenciaTotal += valor;
          } else {
            item.Art.existenciaTotal = valor;
          }
          item.ultimaExistenciaGuardada = valor;
        }
      });
    },
    async confirmarGuardarLinea() {
      const item = this.dialogoConfirmacion.item;
      this.dialogoConfirmacion.visible = false;

      if(item.Existencia < 0){

        alert("No se guardara una cantidad menor a 0 o negativa");
        return;
      }

      if (item) {
        await this.realizarGuardado(item);
      }
    },

  async realizarGuardado(item) {
    try {
      const res = await axios.post(`${this.urlRaiz}/api/inventario/saveLinea`, {
        InventarioId: this.inventario.InventarioId,
        ZonaId: this.zonaId,
        PerId: this.filtrosGeneral.PerId,
        ArtId: item.Art.xarticulo_id,
        Existencia: item.Existencia
      }, {
        headers: { Authorization: localStorage.getItem("token") }
      });

      if (res.data.Success) {
        this.$set(item, 'guardadoCorrectamente', true);
        return true;
      } else {
        item.errorValidacion = true;
        alert(`Error al guardar la línea del artículo ${item.Art.xdescripcion}`);
        return false;
      }
    } catch (e) {
      item.errorValidacion = true;
      alert(`Error al guardar existencia del artículo ${item.Art.xdescripcion}`);
      return false;
    }
  },

  async cargarLineasIntroducidas() {
  this.loadingLineasIntroducidas = true;
  try {
    const res = await axios.post(`${this.urlRaiz}/api/inventario/getLineasIntroducidasEkon`, {
      InventarioId: this.inventario.InventarioId,
      EmpId: this.empId,
      DirId: this.$store.state.dirId
    }, {
      headers: { Authorization: localStorage.getItem("token") }
    });

    if (res.data.Success) {
      this.lineasIntroducidas = res.data.Lineas.map(l => ({
        InventarioArtId: l.InventarioArtId, // Identificador único de la línea
        Art: {
          xarticulo_id: l.Art.ArtCod,
          xdescripcion: l.Art.ArtNom,
          familia: l.Art.Familia,
          subfamilia: l.Art.Subfamilia,
          unidadPrincipal: l.Art.Unidad
        },
        Existencia: l.Existencia,
        ZonaId: l.ZonaId,
        ajuste: 0,
        guardadoOk: false,
        new: false
      }));
    } else {
      alert("Error al cargar artículos introducidos");
    }
  } catch (e) {
    alert("Error al obtener artículos introducidos");
  } finally {
    this.loadingLineasIntroducidas = false;
  }
},

  // async cargarLineasIntroducidas() {
  //   this.loadingLineasIntroducidas = true;
  //   try {
  //     const res = await axios.get(`${this.urlRaiz}/api/inventario/lineas/${this.inventario.InventarioId}`, {
  //       headers: { Authorization: localStorage.getItem("token") }
  //     });

  //     if (res.data.Success) {
  //       this.lineasIntroducidas = res.data.Lineas.map(l => ({
  //         InventarioArtId: l.InventarioArtId, // Guardar el identificador único
  //         Art: {
  //           xarticulo_id: l.Art.ArtCod,
  //           xdescripcion: l.Art.ArtNom,
  //           familia: l.Art.Familia,
  //           subfamilia: l.Art.Subfamilia,
  //           unidadPrincipal: l.Art.Unidad
  //         },
  //         Existencia: l.Existencia,
  //         ajuste: 0,
  //         guardadoOk: false,
  //         new: false
  //       }));
  //     } else {
  //       alert("Error al cargar artículos introducidos");
  //     }
  //   } catch (e) {
  //     alert("Error al obtener artículos introducidos");
  //   } finally {
  //     this.loadingLineasIntroducidas = false;
  //   }
  // },
  esAjusteValido(valor, item) {
    if (valor == null || isNaN(valor) || valor === 0) return false;

    const unidad = item.Art.unidadPrincipal?.toUpperCase();

    if (unidad === 'UN') {
      return Number.isInteger(valor) && valor >= -1000 && valor <= 1000 && valor !== 0;
    } else {
      return valor >= -200 && valor <= 200 && valor !== 0;
    }
  },
  async aplicarAjuste(item) {
    const nuevoValor = item.Existencia + item.ajuste;

    if (nuevoValor < 0) {
      alert("No se puede dejar la existencia en negativo.");
      return;
    }

    try {
      const res = await axios.post(`${this.urlRaiz}/api/inventario/updateLinea`, {
        InventarioArtId: item.InventarioArtId,
        Existencia: nuevoValor
      }, {
        headers: { Authorization: localStorage.getItem("token") }
      });

      if (res.data.Success) {
        item.Existencia = nuevoValor;
        item.ajuste = 0;

        item.guardadoOk = true; // ✅ mostramos check

        // Ocultar icono tras 2 segundos
        setTimeout(() => {
          item.guardadoOk = false;
        }, 2000);
      } else {
        alert("Error al guardar el ajuste");
      }
    } catch (e) {
      alert("Error al aplicar ajuste");
    }
  }
    // async guardarExistenciaLinea(item) {
    //   this.validarExistenciaCampo(item);
    //   if (item.errorValidacion) return;

    //   try {
    //     const res = await axios.post(`${this.urlRaiz}/api/inventario/saveLinea`, {
    //       InventarioId: this.inventario.InventarioId,
    //       ZonaId: this.zonaId,
    //       PerId: this.filtrosGeneral.PerId,
    //       ArtId: item.Art.xarticulo_id,
    //       Existencia: item.Existencia
    //     }, {
    //       headers: { Authorization: localStorage.getItem("token") }
    //     });

    //     if (!res.data.Success) {
    //       item.errorValidacion = true;
    //       alert(`Error al guardar la línea del artículo ${item.Art.xdescripcion}`);
    //     }else{
    //       this.$set(item, 'guardadoCorrectamente', true);

    //     }
    //   } catch (e) {
    //     item.errorValidacion = true;
    //     alert(`Error al guardar existencia del artículo ${item.Art.xdescripcion}`);
    //   }
    // }
  },

};
</script>

<style scoped>
.v-text-field,
.v-autocomplete,
.v-select {
  max-width: 100%;
}
</style>
